



























import { mixin as clickaway } from 'vue-clickaway';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({ mixins: [clickaway] })
export default class SelectPopover extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() options!: any;

  @Prop() value!: string;

  @Prop() enabled!: boolean;

  @Prop() counterEnabled!: boolean;

  expanded = false;

  selectedOption = undefined;

  @Watch('options')
  @Watch('value')
  watchOptions() {
    this.setValue();
  }

  get filteredOptions() {
    return this.options;
  }

  created() {
    this.setValue();
  }

  setValue() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.selectedOption = this.options.find((option: any) => option.key === this.value) || {
      text: this.value
    };
  }

  selectValue(value: string) {
    this.collapse();
    this.$emit('change', value);
  }

  toggleExpand() {
    if (this.enabled) {
      this.expanded = !this.expanded;
    }
  }

  collapse() {
    this.expanded = false;
  }
}
